import script from "./Machine.vue?vue&type=script&setup=true&lang=ts"
export * from "./Machine.vue?vue&type=script&setup=true&lang=ts"

import "./Machine.vue?vue&type=style&index=0&id=6deb3350&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6deb3350"]])

export default __exports__